import { render } from "./Search.vue?vue&type=template&id=406db136&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "@/shared/css/search.css?vue&type=style&index=0&lang=css&external"
import "./Search.vue?vue&type=style&index=1&id=406db136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406db136"]])

export default __exports__